var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"outlined":"","tile":""}},[_c('RawMaterialsTable',{attrs:{"rawmaterials":_vm.material.children}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }